<template>
  <!-- 登陆页 -->
  <div class="login">
    <img
      src="../../assets/images/updataFile/login-logo.png"
      class="login-logo"
    />
    <div class="loginFrom">
      <label for="Mobile" class="userName">
        <input
          type="tel"
          @blur="inputBlue(loginInfo.mobile)"
          v-model="loginInfo.mobile"
          name="Mobile"
          placeholder="请输入手机号码"
        />
      </label>
      <div class="code" v-if="type == 1">
        <label for="code">
          <input
            type="tel"
            placeholder="请输入验证码"
            oninput="if(value.length>6)value=value.slice(0,6)"
            id="code"
            v-model="loginInfo.code"
            name="code"
          />
        </label>
        <div
          :class="['getCode', setFlag ? '' : 'active']"
          @click="getCode(loginInfo.mobile)"
        >
          {{ codeBtnText }}
        </div>
      </div>
      <div class="code" v-else>
        <label for="pwd">
          <input
            type="tel"
            placeholder="请输入密码"
            oninput="if(value.length>8)value=value.slice(0,8)"
            id="pwd"
            v-model="loginInfo.pwd"
            name="pwd"
          />
        </label>
      </div>
      <div class="loginBtn" @click="login">登录</div>
      <div class="tips" @click="type = !type">
        切换为{{ type ? "密码" : "验证码" }}登录
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  data() {
    return {
      loginInfo: {
        mobile: "",
        code: "",
        openId: "",
        pwd: "",
        doctorId: "1263309689931636737",
      },
      Password: "",
      codeBtnText: "获取验证码",
      AgreementFlag: true, //用户协议是否同意
      // 获取验证码的状态
      setFlag: true,
      url: "", //进入登录页面的路径
      type: true,
    };
  },
  created() {
    if (localStorage.getItem("userInfo")) {
      if (localStorage.getItem("redirect"))
        this.$router.replace({
          path: localStorage.getItem("redirect"),
        });
      else
        this.$router.replace({
          name: "MyTesting",
        });
    } else {
      if (this.$isWeixin()) {
        if (this.$route.query.openId == "wxOpenId")
          location.href = `https://api.ibnsina360.com/wechat/authorize?returnUrl=${escape(
            location.href
          )}`;
        else {
          this.loginInfo.openId = this.$route.query.openId;
        }
      }
    }
    //  /verificationCode/sendLoginCode  发送短信登录
    //  /userInfo/userLogin 用户登录
  },
  methods: {
    /**
     * 失去焦点
     */
    inputBlue(Mobile) {
      if (this.$store.state.closureFlag) {
        this.$store.state.closureFlag = false;
        let phoneRes = /^1[0-9]{10}$/;
        if (!phoneRes.test(Mobile)) {
          this.$toots("请输入正确的手机号");
        } else {
          this.$store.state.closureFlag = true;
        }
      }
    },
    /**
     * 发送验证码
     */
    getCode(Mobile) {
      let phoneRes = /^1[0-9]{10}$/;
      if (this.$store.state.closureFlag && this.setFlag) {
        this.$store.state.closureFlag = false;
        if (Mobile == "") {
          this.$toots("请输入手机号");
        } else if (!phoneRes.test(Mobile)) {
          this.$toots("请输入正确的手机号");
        } else {
          this.$loading("发送中");
          this.$http
            .post(`/verificationCode/sendLoginCode?mobile=${Mobile}`)
            .then((res) => {
              if (res.data.code == 200) {
                this.setFlag = false;
                this.$toots("发送成功");
                this.codeBtnText = "60秒后可重新获取";
                let second = 60;
                let id = setInterval(() => {
                  second--;
                  if (second == 0) {
                    this.codeBtnText = "获取验证码";
                    this.setFlag = true;
                    clearInterval(id);
                    return false;
                  }
                  this.codeBtnText = second + "秒后可重新获取";
                }, 1000);
              } else this.$toots("系统正在升级，请稍后");
            })
            .catch((err) => {
              this.$toots("系统正在升级，请稍后");
            });
        }
      }
    },
    /**
     *  点击登录
     */
    login() {
      if (this.$store.state.closureFlag) {
        this.$store.state.closureFlag = false;
        let loginInfo = this.loginInfo;
        let phoneRes = /^1[0-9]{10}$/;
        if (loginInfo.mobile == "") this.$toots("手机号不能为空");
        else if (!phoneRes.test(loginInfo.mobile))
          this.$toots("请输入正确的手机号");
        else if (loginInfo.code == "" && this.type) this.$toots("请输入验证码");
        else if (loginInfo.pwd == "" && !this.type) this.$toots("请输入密码");
        // else if (!this.AgreementFlag) this.$toots("请勾选用户协议");
        else {
          this.$loading("登录中");
          this.$http
            .post(`/userInfo/userLogin`, loginInfo, { qs: "no" })
            .then((res) => {
              if (res.data.code == 200) {
                let data = res.data.data;
                localStorage.setItem("userInfo", JSON.stringify(data));
                this.$store.state.closureFlag = true;
                this.$store.state.loadingFlag = false;
                if (localStorage.getItem("redirect"))
                  this.$router.replace({
                    path: localStorage.getItem("redirect"),
                  });
                else
                  this.$router.replace({
                    name: "MyTesting",
                  });
              } else if (res.data.code == 400) this.$toots(res.data.msg);
              else this.$toots("系统正在升级，请稍后");
            })
            .catch((err) => {
              this.$toots("系统正在升级，请稍后");
            });
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.login {
  padding: 108px 54px 0px 54px;
  height: 100%;
  background-color: #fff;
  .login-logo {
    width: 250px;
    height: 207px;
    display: block;
    margin: 0 auto;
  }
  .wlzs-logo {
    width: 174px;
    height: 193px;
    display: block;
    margin: 0 auto;
  }
  .loginFrom {
    margin-top: 60px;
    .userName,
    .code {
      display: block;
      padding-top: 44px;
      height: 128px;
      border-bottom: 1px solid #eee;
    }
    .code {
      display: flex;
      justify-content: space-between;
      label {
        width: 300px;
      }
      input {
        flex: 1;
      }
      .getCode.active {
        color: #ccc;
      }
      .getCode {
        flex: 1;
        color: #1968a8;
        font-size: 30px;
        text-align: right;
      }
    }
    input {
      font-size: 30px;
      color: #333;
    }
    .loginInput {
      color: #cccccc;
      font-size: 30px;
    } // 用户协议
    .userProtocol {
      padding-top: 28px;
      display: flex;
      font-size: 26px;
      line-height: 50px;
      color: #888888;
      label {
        margin-right: 10px;
        width: 26px;
        height: 26px;
        border: 1px solid #ccc;
        transform: translateY(50%);
      }
      label.active {
        background: url(../../assets/images/updataFile/checkOut-icon.png)
          no-repeat center;
        background-size: 17px 14px;
      }
      .describe {
        line-height: 54px;
      }
      .protocot {
        color: #222;
      }
    } // 立即录按钮
    .loginBtn {
      width: 100%;
      margin-top: 60px;
      height: 98px;
      line-height: 98px;
      border-radius: 10px;
      background-color: #1968a8;
      color: #fff;
      text-align: center;
      font-size: 34px;
    }
    .tips {
      font-size: 30px;
      text-align: center;
      margin-top: 100px;
      color: #1968a8;
    }
  }
}
</style>


